import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { Panel, PanelHeader, PanelBody } from '../../header/panel/panel';
import { fetchProcessorTerminalsForAssignment } from '../../../redux/actions/DropdownActions';
import { assignProcessorTermID, unassignProcessorTermID } from '../../../redux/actions/TerminalActions';

const AssignProcessorTerminalIDForm = (props) => {

    const [processorTermID, setProcessorTermID] = useState('')
    const [connectionID, setConnectionID] = useState('')
    const [processorID, setProcessorID] = useState('')

    const [, setProcessorTermIDError] = useState(false)

    const [connectionsDropdown, setConnectionsDropdown] = useState([])
    const [processorTerminalsDropdown, setProcessorTerminalsDropdown] = useState([])



    useEffect(() => {
        console.log('Merchant ID : ' + props.merchantID)
        props.fetchProcessorTerminalsForAssignment(props.merchantID)
        console.log('TIDs available ', props.DROPDOWNREDUCER.processorTerminals)
    }, [])

    const handleAssignPTID = () => {

        let body = {}
        body.processorTermID = processorTermID
        body.terminalID = props.terminalID
        body.merchantID = props.merchantID


        if (body.processorTermID, body.groupID, body.merchantID) {
            console.log('Assign Data : ', body)
            props.assignProcessorTermID(body)
            props.setAddModelOpen(false)
        }

    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'processorID':
                setProcessorID(targetValue)
                let connections = props.DROPDOWNREDUCER.processorTerminals.filter(processor => {
                    return String(processor.processorID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setConnectionsDropdown(connections[0]?.processorConnections)
                break;
            case 'connectionID':
                setConnectionID(targetValue)

                let processorTerminal = connectionsDropdown.filter(connection => {
                    return String(connection.connectionID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setProcessorTerminalsDropdown(processorTerminal[0]?.processorTermID)
                break;
            case 'processorTermID':
                setProcessorTermID(targetValue)
                setProcessorTermIDError(false)
                break;
            default:
                break;

        }

    }


    return (

        <Panel >
            <PanelHeader>ADD PROCESSOR TERMINAL FORM</PanelHeader>
            <PanelBody>

                <form className="fs-13px">

                    <div className="mb-3">

                        <div className="row gx-6">

                            <div className="col-md-12 mb-12 mb-md-2">
                                <select className="form-select"
                                    onChange={handleChange}
                                    name='processorID'
                                    value={processorID ? processorID : ' '}
                                >
                                    <option value=''>Select Processor</option>
                                    {props.DROPDOWNREDUCER.processorTerminals.length > 0 ? props.DROPDOWNREDUCER.processorTerminals.map((option) => (
                                        <option key={option.processorID} value={option.processorID}>
                                            {option.processorName}
                                        </option>
                                    ))
                                        : <></>
                                    }

                                </select>
                            </div>
                            <div className="col-md-12 mb-12 mb-md-2">
                                <select className="form-select"
                                    onChange={handleChange}
                                    name='connectionID'
                                    value={connectionID ? connectionID : ''}
                                >
                                    <option value=''>Select Connection</option>
                                    {connectionsDropdown.map((option) => (
                                        <option key={option.connectionID} value={option.connectionID}>
                                            {option.connectionName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-12 mb-12 mb-md-2">
                                <select className="form-select"
                                    value={processorTermID ? processorTermID : ''}
                                    onChange={handleChange}
                                    name='processorTermID'
                                >
                                    <option value=''>Select Processor Terminal</option>
                                    {processorTerminalsDropdown?.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}


                                </select>
                            </div>

                                <div className="row gx-3">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                        <button className='btn btn-gray d-block w-100 btn-lg h-9px fs-13px' onClick={() => props.setAddModelOpen(false)}>Cancel</button>
                                </div>
                                    <div className="col-md-6 mb-2 mb-md-0">
                                        <button className='btn btn-primary d-block w-100 btn-lg h-9px fs-13px' onClick={handleAssignPTID}>{'Add'}</button>
                                    </div>
                            </div>

                        </div>
                    </div>

                </form>

            </PanelBody>
        </Panel>

    )

}


function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    assignProcessorTermID,
    unassignProcessorTermID,
    fetchProcessorTerminalsForAssignment

}


export default connect(mapStateToProps, mapDispatchToProps)(AssignProcessorTerminalIDForm);
